import { render, staticRenderFns } from "./ShippingStep.vue?vue&type=template&id=2707e260&scoped=true&lang=pug&"
import script from "./ShippingStep.vue?vue&type=script&lang=js&"
export * from "./ShippingStep.vue?vue&type=script&lang=js&"
import style0 from "./ShippingStep.vue?vue&type=style&index=0&id=2707e260&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2707e260",
  null
  
)

export default component.exports